// Import from repo root - this is the customer-facing changelog
import changelogMarkdown from '../../../../CHANGELOG.md?raw';

export const CHANGELOG_MENU_LABEL = 'Changelog';
export const CHANGELOG_MARKDOWN = changelogMarkdown;
